export const truthyOrElse = <T, F>(value: T, fallback: () => F): NonNullable<T> | F => {
  if (value) return value;
  return fallback();
};
